import { render, staticRenderFns } from "./PostComponent.vue?vue&type=template&id=75c2f514&scoped=true"
import script from "./PostComponent.vue?vue&type=script&lang=js"
export * from "./PostComponent.vue?vue&type=script&lang=js"
import style0 from "./PostComponent.vue?vue&type=style&index=0&id=75c2f514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c2f514",
  null
  
)

export default component.exports